import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { AthletemultitransferComponent } from './athlete-multitransfer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule, JsonpModule } from '@angular/http';

const routes: Routes = [{
	path: '',
	data: {
      title: 'Athlete Transfer Process',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Athlete Transfer'}]
    },
	component: AthletemultitransferComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule,
		HttpModule,
        JsonpModule,
        NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [AthletemultitransferComponent]
})
export class AthletemultitransferModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/school/athlete-multitransfer/athlete-multitransfer.module.ts